import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import {
  AlertModule,
  ContainerComponent,
  INavData,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarService,
} from '@coreui/angular';

import { DefaultFooterComponent, DefaultHeaderComponent } from './';

import { AlertsService } from '../../services/alerts.service';
import { Alert } from '../../models/generic/alert.model';
import { Subscription } from 'rxjs';
import { GameSidebarService } from '../../services/game-sidebar.service';
import { ApplicationsService } from '../../services/applications/applications.service';


function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    NgScrollbar,
    SidebarNavComponent,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    AlertModule
]
})
export class DefaultLayoutComponent implements OnInit {
  public navItems: INavData[] = [];
  
  public alerts: Alert[] = [];

  private sidebarNavItemsSubscription: Subscription;
  private alertSubscription: Subscription;

  constructor(private gameSidebarService: GameSidebarService, private alertsService: AlertsService, public applicationsService: ApplicationsService) {
    this.sidebarNavItemsSubscription = new Subscription();
    this.alertSubscription = new Subscription();
  }
  
  ngOnInit() {
    this.alertSubscription = this.alertsService.alert$.subscribe(
      (alert: Alert) => {
        this.alerts.push(alert);

        // Remove the alert with a timeout
        setTimeout(() => {
          this.alerts.splice(0, 1);
        }, alert.timeout);
      });

      this.navItems = this.gameSidebarService.getSidebarItems();

      this.sidebarNavItemsSubscription = this.gameSidebarService.sidebarNavItemsSubject.subscribe(
        (sidebarNavItems: INavData[]) => {
          this.navItems = sidebarNavItems;
      });
  }
}
